
import { JournalEntry } from '../models/Txn_JournalEntry';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http, Headers, RequestOptionsArgs } from '@angular/http';
import { GL_Child } from '../models/GL_Child';
import 'rxjs/add/operator/map';
import { Txn_Invoice } from '../models/Txn_Invoice';

@Injectable()

export class Acc_Txn_Service {
  private readonly Txn_DE_Endpoint = '/api';
  headers: any;
  headers2: any;
  constructor(
    //private http: HttpClient,
    private http: Http) {
    this.headers = new Headers({ 'Content-Type': 'application/json' });
    this.headers.append('Accept', `application/json`);
    let authToken = localStorage.getItem('auth_token');
    this.headers.append('Authorization', `Bearer ${authToken}`);

    this.headers2 = new Headers(); //{ 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryKvKU7mWeaVnxHt43' });
    this.headers.append('Accept', `application/json`);
    this.headers2.append('Content-Length', '68137');
    //this.headers2.append('Content-Disposition', 'form-data; name="description"');    
    this.headers2.append('Authorization', `Bearer ${authToken}`);

  }

  CreateTxn_DE_Contract(txns: JournalEntry[]) {
    return this.http.post(this.Txn_DE_Endpoint + '/Txn_JournalEntry/', txns, { headers: this.headers });
  }

  CreateTxn_DE_Contract_Files(txns: FormData) {
    return this.http.post(this.Txn_DE_Endpoint + `/Txn_Expense/Create_Jour_all`, txns, { headers: this.headers2 })
  };

  CreateTxn_DE_Contract_File(txns: any) {
    return this.http.post(this.Txn_DE_Endpoint + `/Txn_JournalEntry/Create_JournalEntry_File`, txns, { headers: this.headers })
  };
  
  CreateTxn_Invoice(txn: Txn_Invoice, prntSelectedBankAccount, prntSelectedBankNumber) {
    console.log("invoice type -->" + txn.invoiceType);
    return this.http.post(this.Txn_DE_Endpoint + `/Txn_Invoice/${prntSelectedBankAccount}/${prntSelectedBankNumber}/`, txn, { headers: this.headers })
  }

  ClearInvoice_Invoice(txns: JournalEntry[], inv_no: number) {
    return this.http.post(this.Txn_DE_Endpoint + `/Txn_InvoiceClear/${inv_no}`, txns, { headers: this.headers })
  }

  getJournalList(GL_Master: string, GL_Child: string, fromDate: string, toDate: string, statusId: number, typeId: number, branchId: number, userId: string) {
    return this.http.get(this.Txn_DE_Endpoint + '/Txn_JournalEntry?GL_Master=' + GL_Master + '&GL_Child=' + GL_Child + '&fromDate=' + fromDate + '&toDate=' + toDate + '&statusId=' + statusId + '&typeId=' + typeId + '&branchId=' + branchId + '&userId=' + userId, { headers: this.headers });
  }
  

  updateJournalEntry(jour: JournalEntry) {
    return this.http.post(this.Txn_DE_Endpoint + '/Txn_JournalEntry/updateJournalEntry/', jour, { headers: this.headers });
  }


  updatePrintJournalEntry(exp: JournalEntry) {
    return this.http.post(this.Txn_DE_Endpoint + '/Txn_JournalEntry/updatePrintJournalEntry/', exp, { headers: this.headers });
  }

  updateStatusJournalEntry(exp: JournalEntry) {
    return this.http.post(this.Txn_DE_Endpoint + '/Txn_JournalEntry/updateStatusJournalEntry/', exp, { headers: this.headers });

  }

  deleteJournalEntry(trn_ref_no: string) {
    return this.http.delete(this.Txn_DE_Endpoint + '/Txn_JournalEntry?trn_ref_no=' + trn_ref_no + "&username=test", { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/Acc_Txn_Servcies.ts